<template>
  <div>
    <div>
      <h5>
        所有包含<q>{{ tagName }}</q
        >的活跃话题
      </h5>
    </div>
    <div class="row">
      <el-tabs v-model="activeSorting" class="col-md-9 order-2 order-md-1">
        <el-tab-pane label="最新发布" name="publish" tabindex="0" :lazy="true">
          <TopicCard
            :queryParams="{ order: 'published' }"
            :key="tagId + 'published'"
          ></TopicCard>
        </el-tab-pane>
        <el-tab-pane label="最新回复" name="reply" tabindex="1" :lazy="true">
          <TopicCard :queryParams="{ order: 'reply' }" :key="tagId"></TopicCard>
        </el-tab-pane>
      </el-tabs>
      <TopicListRightMenuComponent
        class="col-md-3 order-1 order-md-2"
        v-bind:key="id"
      ></TopicListRightMenuComponent>
    </div>
  </div>
</template>

<script>
import TopicCard from "../components/TopicCardComponent.vue";
import TopicListRightMenuComponent from "../components/TopicListRightMenuComponent.vue";
import { mapMutations } from "vuex";

export default {
  data: function() {
    return {
      activeSorting: "publish"
    };
  },
  props: ["tagId", "tagName"],
  components: {
    TopicCard,
    TopicListRightMenuComponent
  },
  methods: {
    ...mapMutations(["setUrls", "changeCurrentCategory"]),
    updateCategory: function() {
      this.changeCurrentCategory("");
      this.setUrls({
        topicsUrl: "/tags/" + this.tagId,
        tagsUrl: "/tags/"
      });
    }
  },
  // when the view is first called and mounted.
  beforeMount() {
    this.updateCategory();
  },
  // when id is changed by the router
  beforeUpdate() {
    this.updateCategory();
  }
};
</script>
